import { createStoreTokenWrapper } from '@egreact/shared';
import { useStateFields } from '../store/hooks';
import * as CONST from '../script/const';
import { isAdmin, sendPosthogInfo } from '../script/util';

// Auth context the shared wrapper expects ({ isLoggedin, setisLoggedin, setuserDetails, ... }),
// now sourced from Redux instead of the removed StateContext.
const useSession = () => useStateFields(['isLoggedin', 'userDetails']);

/**
 * StoreToken wrapper component using shared factory
 * This maintains backward compatibility with existing code
 */
const StoreToken = createStoreTokenWrapper({
  useStateContext: useSession,
  getBaseUrl: () => CONST.S_URL,
  getIsAdmin: isAdmin,
  getSendPosthogInfo: sendPosthogInfo
});

export default StoreToken;
